import { imageCdnUrl } from '../../shared/constants/cdn.constants';
import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent {

  pageTitle = '';
  pageSubTitle = '';
  pageBg = '';
  showBanner = false;

  // ✅ Single shared breadcrumb image used across all inner pages
  private readonly defaultBg =
    imageCdnUrl('saikheda.webp');

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {

        // remove query params, hash etc.
        const url = event.urlAfterRedirects.split('?')[0].split('#')[0];

        /* ===============================
           ❌ HIDE ON HOME PAGE
        =============================== */
        if (url === '/' || url === '' || url === '/home' || url === '/home/') {
          this.showBanner = false;
          this.pageTitle = '';
          this.pageSubTitle = '';
          this.pageBg = '';
          return;
        }

        /* ===============================
           ✅ SHOW ON INNER PAGES
        =============================== */
        this.showBanner = true;
        this.pageBg = this.defaultBg;

        /* ---------- ABOUT ---------- */
        if (url === '/about/about-ghru' || url.startsWith('/about/about-ghru/')) {
          this.pageTitle = 'About';
          this.pageSubTitle = 'About Ghru';
        }
        if (url === '/about/about-raisoni' || url.startsWith('/about/about-raisoni/')) {
          this.pageTitle = 'About';
          this.pageSubTitle = 'About Raisoni Group';
        }
        if (url === '/about/social-initiatives' || url.startsWith('/about/social-initiatives/')) {
          this.pageTitle = 'Social Initiatives';
          this.pageSubTitle = 'Social Initiatives';
        }
        if (url === '/about/leadership' || url.startsWith('/about/leadership/')) {
          this.pageTitle = 'Leadership';
          this.pageSubTitle = 'Leadership';
        }

        /* ---------- CAMPUS LIFE ---------- */
        if (url === '/campus-life/hostel' || url.startsWith('/campus-life/hostel/')) {
          this.pageTitle = 'Hostel';
          this.pageSubTitle = 'Hostel';
        }
        if (url === '/campus-life/sports' || url.startsWith('/campus-life/sports/')) {
          this.pageTitle = 'Sports';
          this.pageSubTitle = 'Sports';
        }
        if (url === '/campus-life/library' || url.startsWith('/campus-life/library/')) {
          this.pageTitle = 'Library';
          this.pageSubTitle = 'Library';
        }

        /* ---------- ADMISSION ---------- */
        if (url === '/admission-procedure' || url.startsWith('/admission-procedure/')) {
          this.pageTitle = 'Admission Procedure';
          this.pageSubTitle = 'Admission Procedure';
        }
      }
    });
  }
}